import React from "react";
import ShowNotifcation from "./components/ShowNotifcation";
import { NavLink, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const NotificationsPage = () => {
    const role = useSelector((store) => store.userReducer.role);
  return (
    <>
      <h2>Notifications</h2>
      <nav className="navbar-activity">
        <div className="nav-links-activity">
          <NavLink
            to="/notifications/duplicate-webhook"
            className={({ isActive }) => (isActive ? "active-tab" : "")}
          >
            Duplicate webhook
          </NavLink>
          <NavLink
            to="/notifications/chargeback-tnx"
            className={({ isActive }) => (isActive ? "active-tab" : "")}
          >
            Chargeback
          </NavLink>
          <NavLink
            to="/notifications/error-webhoook"
            className={({ isActive }) => (isActive ? "active-tab" : "")}
          >
            Error webhooks
          </NavLink>
          <NavLink
            to="/notifications/suspicious-tnx"
            className={({ isActive }) => (isActive ? "active-tab" : "")}
          >
            Suspicious transactions
          </NavLink>
         {role === 'super' && <NavLink
            to="/notifications/whitelist-requests"
            className={({ isActive }) => (isActive ? "active-tab" : "")}
          >
            IP Whitelist requests
          </NavLink>}
        </div>
      </nav>
       <div>
                  <Outlet/>
              </div>
      {/* <ShowNotifcation /> */}
    </>
  );
};

export default NotificationsPage;
